import React from 'react'
import Image from 'next/image'
import questLogo from '@/assets/images/refresh/featured-category/labs/quest.webp'
import labcorpLogo from '@/assets/images/refresh/featured-category/labs/labcorp.webp'
import classes from './LabsLeading.module.css'

const LAB_LOGOS = [
    { src: questLogo, alt: '' },
    { src: labcorpLogo, alt: '' },
] as const

/** Circular Quest / Labcorp stack for lab-test featured cards. */
export default function LabsLeading() {
    return (
        <div className={classes.stack} aria-hidden>
            {LAB_LOGOS.map((logo) => (
                <span key={logo.src.src} className={classes.circle}>
                    <Image
                        src={logo.src}
                        alt={logo.alt}
                        fill
                        sizes="48px"
                        className={classes.image}
                        loading="lazy"
                        decoding="async"
                    />
                </span>
            ))}
        </div>
    )
}
